import axios from 'axios';
import {
  CHANGE_BRAND_ORDER, CREATE_BRAND_EQUIPMENT,
  DELETE_BRAND, FETCH_ALL_BRANDS, FETCH_ALL_TRAINER_BRANDS, FETCH_ALL_NCEP_TRAINER_BRANDS, FETCH_BRAND, FETCH_BRAND_EQUIPMENT,
  FETCH_REFERENCE_DETAIL, UPDATE_BRAND,
  UPDATE_BRAND_EQUIPMENT
} from '../actionTypes';
import { showAlert } from './alert';
import { addError } from './errors';
import { hideLoader, showLoader } from './loader';

const SERVICE = 'brand';

export const fetch = query => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios.get(SERVICE, query).then(async res => {
			dispatch({
				type: FETCH_BRAND,
				payload: res.data,
			});
			await axios
				.get('equipment', { params: { brandId: res.data._id } })
				.then(res => {
					dispatch(hideLoader());
					dispatch({
						type: FETCH_BRAND_EQUIPMENT,
						payload: Object.values(res.data)[0],
					});
				});
			response(res.data);
		});
	});
};

export const update = brandData => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios
			.patch(SERVICE, brandData)
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: UPDATE_BRAND,
					payload: res.data,
				});
				dispatch(
					showAlert(res.data.message || 'Information has been saved successfully.')
				);
				delete res.data.message;
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				return dispatch(
					showAlert(err.message || 'Error while updating profile.', true)
				);
			});
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT;
	});
};

export const adminUpdate = (brand_id, brandData) => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios
			.patch(`${SERVICE}/manage/edit/${brand_id}`, brandData)
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: UPDATE_BRAND,
					payload: res.data,
				});
				dispatch(showAlert(res.data.message || 'Information has been saved successfully.'));
				response(res.data);
			})
			.catch(err => {
				handleError(dispatch, err);
				reject();
			});
	});
};

export const deleteBrand = brand_id => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios
			.patch(`${SERVICE}/manage/delete/${brand_id}`)
			.then(res => {
				dispatch(hideLoader());
				dispatch(showAlert('Information has been deleted successfully.'));
				dispatch({
					type: DELETE_BRAND,
				});
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				if (err.response) {
					dispatch(addError(err.response.data.error.message));
				}
				reject();
			});
	});
};

export const createEquipment = data => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post('equipment', data)
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: CREATE_BRAND_EQUIPMENT,
					payload: res.data,
				});
				dispatch(
					showAlert(
						res.data.message || 'Equipment has been created successfully.'
					)
				);
				delete res.data.message;
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				if (err.response) {
					dispatch(showAlert(err.response.data.error.message, true));
				}
				reject();
			});
	});
};

export const updateBrandPicture = brandData => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`${SERVICE}/manage/updatePicture/${brandData._id}`, brandData)
			.then(res => {
				dispatch(hideLoader());
				dispatch(showAlert(res.data.message));
				response(res.data);
			})
			.catch(e => {
				dispatch(hideLoader());
				if (e.response) {
					dispatch(addError(e.response.data.error.message));
				}
				reject();
			});
	});
};

export const updateEquipment = (data, editId) => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios
			.patch(`equipment/${editId}`, data)
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: UPDATE_BRAND_EQUIPMENT,
					payload: res.data,
				});
				dispatch(
					showAlert(
						res.data.message || 'Equipment has been updated successfully.'
					)
				);
				delete res.data.message;
				response(res.data);
			})
			.catch(err => {
				handleError(dispatch, err);
				reject();
			});
	});
};

export const fetchAll = (isAgency, isNCEP) => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios.get(`${SERVICE}/all?isAgency=${isAgency}&isNCEP=${isNCEP}`, {
		}).then(res => {
			dispatch(hideLoader());
			if(isAgency && isNCEP) {
				dispatch({
					type: FETCH_ALL_NCEP_TRAINER_BRANDS,
					payload: res.data,
				});
			} else if(isAgency && !isNCEP) {
			  dispatch({
				type: FETCH_ALL_TRAINER_BRANDS,
				payload: res.data,
			  });
		    } else {
				dispatch({
				  type: FETCH_ALL_BRANDS,
				  payload: res.data,
				});
			  }
		});
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT;
	});
};

export const changeOrder = orderData => dispatch => {
	return new Promise((response, reject) => {
		dispatch(showLoader());
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`${SERVICE}/manage/updateOrder`, orderData)
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: CHANGE_BRAND_ORDER,
					payload: res.data,
				});
				dispatch(fetchAll(false));
				dispatch(showAlert(res.data.message));
				response(res.data);
			})
			.catch(err => {
				handleError(dispatch, err);
				reject();
			});
	});
};

export const getBrand = brandId => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios
			.get(`${SERVICE}/${brandId}`, { params: { _embed: 'referenceData' } })
			.then(async res => {
				dispatch(hideLoader());
				response(res.data);
			});
	});
};

export const fetchReferralDetail = (referenceCode, isFollow) => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios
			.get(`users/referenceDetail/${referenceCode}`, {
				params: {
					isFollow,
				},
			})
			.then(async res => {
				dispatch(hideLoader());
				dispatch({
					type: FETCH_REFERENCE_DETAIL,
					payload: res.data,
				});
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				reject();
			});
	});
};

function handleError(dispatch, err) {
	dispatch(hideLoader());
	if (err.response) {
		dispatch(addError(err.response.data.error.message));
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/brand.js